<div class="ovrrride-flange-input-wrap" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="reducedAreaBolting_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Reduced Area Bolting -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.REDUCED_AREA_BOLTING' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #reducedAreaBolting_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.REDUCED_AREA_BOLTING' | transloco }}
        </p>
    </ng-template>
    <div class="example-checkbox">
        <div>
            <mat-checkbox class="example-margin checkbox-wrap" name="resultOptionEl" formControlName="isRedAreaBoltSelected"></mat-checkbox>
        </div>
        <mat-form-field class="example-full-width" [floatLabel]="'never'">
            <input matInput formControlName="redAreaBolt" name="reduce_bolting" placeholder="Minimum area bolting" />
        </mat-form-field>
    </div>
</div>
